(function () {
  'use strict';

  function initReveal(section) {
    if (!section.classList.contains('vc--reveal')) return;

    var targets = section.querySelectorAll('[data-vc-line]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function popButton(btn) {
    btn.classList.remove('is-popping');
    void btn.offsetWidth;
    btn.classList.add('is-popping');
  }

  function refreshHeaderCart() {
    return fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) throw new Error('cart refresh failed');
        return res.json();
      })
      .then(function (cart) {
        var cartIcon = document.querySelector('cart-icon');
        if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
          cartIcon.renderCartBubble(cart.item_count);
        }
      })
      .then(function () {
        return fetch('/?sections=cart-drawer-section', { cache: 'no-store' });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart drawer refresh failed');
        return res.json();
      })
      .then(function (data) {
        var html = data && data['cart-drawer-section'];
        if (!html) return;

        var temp = document.createElement('div');
        temp.innerHTML = html;

        var freshDrawer = temp.querySelector('cart-drawer-component');
        var currentDrawer = document.querySelector('cart-drawer-component');

        if (freshDrawer && currentDrawer) {
          currentDrawer.replaceWith(freshDrawer);
        }
      })
      .catch(function () {});
  }

  function initAddToCart(section) {
    section.querySelectorAll('.vc__tarjeta-boton--anadir').forEach(function (btn) {
      if (btn.tagName === 'A') {
        btn.addEventListener('click', function () {
          popButton(btn);
        });
      }
    });

    var forms = section.querySelectorAll('[data-vc-add-form]');

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var btn = form.querySelector('[data-vc-add-btn]');
        var label = form.querySelector('[data-vc-add-label]');
        if (!btn || btn.disabled) return;

        popButton(btn);
        btn.disabled = true;

        fetch(form.getAttribute('action') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: form.elements['id'].value,
            quantity: parseInt(form.elements['quantity'].value, 10) || 1
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.classList.add('is-added');
            if (label) label.textContent = btn.dataset.labelDone || '¡Añadido!';

            refreshHeaderCart();

            setTimeout(function () {
              btn.classList.remove('is-added');
              if (label) label.textContent = btn.dataset.labelIdle || 'Añadir al carrito';
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            if (label) label.textContent = 'Error, prueba de nuevo';
            setTimeout(function () {
              if (label) label.textContent = btn.dataset.labelIdle || 'Añadir al carrito';
              btn.disabled = false;
            }, 1800);
          });
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.vcInitDone === 'true') return;
    section.dataset.vcInitDone = 'true';

    initReveal(section);
    initAddToCart(section);
  }

  function initAll() {
    document.querySelectorAll('[data-vc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-vc]');
    if (section) {
      section.dataset.vcInitDone = 'false';
      initSection(section);
    }
  });
})();